import { Browser } from '@capacitor/browser';

import { getStudent } from '@/lib/api/generated/student/student';

const { studentLinkTestgate } = getStudent();

/**
 * 이 앱의 커스텀 URL 스킴 — capacitor.config.ts의 appId(com.gate.erp)와 맞춘다.
 * iOS(Info.plist CFBundleURLTypes)·Android(AndroidManifest intent-filter)에도 등록돼 있어야
 * OS가 이 스킴으로 온 리다이렉트를 다시 앱으로 넘겨준다.
 */
const APP_SCHEME = 'com.gate.erp';

/** TestGate가 로그인 완료 후 리다이렉트할 콜백 — useTestgateConnectListener가 이 prefix로 받는다 */
export const TESTGATE_CONNECT_CALLBACK_URL = `${APP_SCHEME}://testgate-connect`;

/**
 * TestGate 계정 연결 시작.
 * 인앱 브라우저로 TestGate(dsat_renewal)의 external-signin 플로우를 연다 — 로그인이 이미 돼 있으면
 * 바로, 안 돼 있으면 로그인 후 TESTGATE_CONNECT_CALLBACK_URL로 accessToken을 담아 리다이렉트한다.
 *
 * dsat_renewal 쪽엔 이 요청을 `isErpSign` 쿼리로 넘긴다 — gateplus 랜딩에서 오는 기존 외부 로그인
 * (`isExternalSign`)과는 완전히 분리된 별도 분기라, 랜딩 흐름이 쓰는 레거시 토큰(refreshAccessToken)이
 * 아니라 방금 로그인으로 발급된 클린 토큰이 돌아온다 (external-signin/Page.jsx, useAuthFlow.ts 참고).
 */
export async function openTestgateConnect() {
  const testgateBaseUrl = import.meta.env.VITE_TESTGATE_URL as string;
  const url = new URL('/auth/external-signin', testgateBaseUrl);
  url.searchParams.set('isErpSign', TESTGATE_CONNECT_CALLBACK_URL);
  url.searchParams.set('lastRoute', '/');
  url.searchParams.set('buttonType', 'mobile-connect');

  await Browser.open({ url: url.toString() });
}

/**
 * 학생 본인 TestGate 계정 연결 (`POST /api/students/me/external-accounts/testgate`).
 * TestGate 로그인으로 발급받은 access token(ERP 토큰과 별개)을 받아 연결한다 — 학생 전용, 학부모는 호출할 수 없다.
 */
export async function linkTestgate(testgateAccessToken: string): Promise<void> {
  const res = await studentLinkTestgate({ testgateAccessToken });
  if (!res.success) throw new Error(res.error?.message ?? 'Test GATE+ 계정 연결에 실패했습니다.');
}
